import { render, staticRenderFns } from "./ThresholdControls.vue?vue&type=template&id=284a890a&scoped=true&"
import script from "./ThresholdControls.vue?vue&type=script&lang=js&"
export * from "./ThresholdControls.vue?vue&type=script&lang=js&"
import style0 from "./ThresholdControls.vue?vue&type=style&index=0&id=284a890a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284a890a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
